import { render, staticRenderFns } from "./MDViewer.vue?vue&type=template&id=447acd8d"
import script from "./MDViewer.vue?vue&type=script&lang=js"
export * from "./MDViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports